import { Container, Navbar, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/just_breathe_white.svg";
import { SlSettings, SlUser } from "react-icons/sl";
import { GoChevronDown } from "react-icons/go";
import { RiLogoutCircleLine } from "react-icons/ri";
import WebService from "../../Services/WebService";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { notificationCount, notificationList, updateProfileImage } from "../../Redux/actions";
import { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import missingImage from "../../assets/images/noImage.png";
import activeUserImage from "../../assets/images/icon-active-user-weekly.svg";
import placeHolder from "../../assets/images/profile-placeholder.png";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const profileImage = useSelector((state: any) => state?.profile?.profileImage ?? "");
  const notificationCountState = useSelector((state: any) => state?.profile?.notificationCount ?? 0);
  const notificationsList = useSelector((state: any) => state?.profile?.notificationList ?? []);
  const dispatch = useDispatch();
  const [image, setImage] = useState("")
  const [notification, setNotification] = useState<any>([]);
  const [count, setCount] = useState(0);
  const [username, setUsername] = useState(localStorage.getItem("admin_name"));
  const [email, setEmail] = useState(localStorage.getItem("admin_email"));
  const navigate = useNavigate()

  const meCall = () => {
    return WebService.getAPI({
      action: `user/me`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        dispatch(updateProfileImage(res.result.userProfileImage));
        localStorage.setItem("profileImage", res.result.userProfileImage);
        setImage(res.result.userProfileImage)
        setUsername(res.result.name)
        setEmail(res.result.email)
      })
      .catch((error) => {
        return error;
      });
  };

  const getWebsocketView = () => {
    let socket = new WebSocket("wss://apiv2.justbreathe.in/live-data");

    socket.onopen = function () {
      socket.send(
        JSON.stringify({
          action: "subscribe",
          topic: `Devices/M2C/notifications`,
        })
      );

      socket.onmessage = (event: any) => {
        let data = JSON.parse(event?.data);
        if (data.topic === `Devices/M2C/notifications`) {
          let parseData = JSON.parse(data?.content);
          setNotification((prevNotifications: any) => [
            ...prevNotifications,
            parseData,
          ]);
          if (!parseData.read) {
            setCount((prevCount: any) => prevCount + 1);
          }
        }

        socket.onclose = function () {
        };
      };
    };
  };

  const handleNotification = () => {
    WebService.getAPI({
      action: `user/notification?page=1`,
      body: null,
      isShowError: true
    }).then((res: any) => {
      setNotification(res?.list)
      dispatch(notificationList(res.list))
      dispatch(notificationCount(res.count))
      setCount(res.count)
    }).catch((error: any) => {
      return false;
    })
  }

  useEffect(() => {
    meCall();
    handleNotification();
    getWebsocketView();
  }, [image, username, email,])

  // useEffect(() => {
  //   localStorage.setItem("admin_name", username);
  //   localStorage.setItem("admin_email", email);
  //   localStorage.setItem("admin_image", image);
  // }, [username, email, image]);

  return (
    <>
      <header className="site-header">
        <Container fluid className="header-nav">
          <Navbar expand="lg">
            <Navbar.Brand className="me-5">
              <img src={Logo} width={235} height={47} alt="Just Breathe" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <div className="d-flex align-items-center ms-auto gap-3">
              <Dropdown className="profile-dd">
                <Dropdown.Toggle>
                  <p className="font-20 mb-0 text-dark font-medium">
                    <FaBell />
                    {count > 0 && (
                      <span className="badge" style={{ color: "green" }}>
                        {notificationCountState}
                      </span>
                    )}
                  </p>
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ maxHeight: '450px', overflowY: 'auto' }}>
                  {notificationsList.length > 0 && (
                    <Dropdown.Item style={{ textAlign: 'center', fontWeight: 'bold' }}>
                      <button
                        onClick={() => navigate('/notification')}
                        style={{ width: '80%', padding: '8px', fontSize: '13px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}
                      >
                        View Notifications
                      </button>
                    </Dropdown.Item>
                  )}

                  {notificationsList.length > 0 ? (
                    notificationsList.map((notification: any, index: any) => (
                      <Dropdown.Item
                        key={index}
                        style={{ position: 'relative' }}
                      >
                        <div style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                          <p>
                            <strong>Title:</strong> {notification.title} <br />
                            <strong>Message:</strong> {notification.message}<br />
                            {/* {notification.companyName && <span><strong>Client:</strong> {notification.companyName}<br /></span>} */}
                            {notification.siteName && <span><strong>Site:</strong> {notification.siteName}<br /></span>}
                            {notification.machineId && <span><strong>MachineId:</strong> {notification.machineId}<br /></span>}
                            {notification.tag && <span><strong>Tag:</strong> {notification.tag}<br /></span>}
                            <strong>Date&Time:</strong> {moment(notification.created_date).format('DD-MM-YYYY, h:mm a')}
                          </p>
                        </div>
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item>No notifications</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="profile-dd">
                <Dropdown.Toggle>
                  <div className="d-flex gap-2">
                    <div>
                      <img
                        src={profileImage ?? placeHolder}
                        width={35}
                        height={35}
                        className=" rounded-circle object-fit-cover"
                        alt=""
                        onError={(error: any) => {
                          meCall()
                          error.target.src = activeUserImage;
                        }}
                      />
                    </div>
                    <div>
                      <p className="font-14 mb-0 text-dark font-medium">
                        {/* {localStorage.getItem("admin_name")} */}
                        {username}
                      </p>
                      <p className="font-12 mb-0 text-secondary">
                        {/* {localStorage.getItem("admin_email")} */}
                        {email}
                      </p>
                    </div>
                  </div>
                  <GoChevronDown size={16} className="icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Link to="/Profile" className=" dropdown-item">
                    <SlUser size={14} className="me-2" /> My Profile
                  </Link>
                  {/* <Link to="/" className=" dropdown-item">
                    <SlSettings size={14} className="me-2" /> Setting
                  </Link> */}
                  <Link
                    to="/login"
                    className=" dropdown-item"
                    onClick={() => {
                      WebService.logout()
                    }}
                  >
                    <RiLogoutCircleLine size={14} className="me-2" /> Logout
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar>
        </Container>
      </header>
    </>
  );
};
export default Header;
